module.exports = __webpack_public_path__ + "img/MaurizioLagomarsini_140x140_rund.c7f35400.jpg";